// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"dcab2da5","141":"d9d84159","235":"9a1f9b16","251":"87bf3c6d","395":"b9773961","453":"1fc890f0","522":"5377c636","671":"cde90b21","683":"3b40ecc7","731":"8cb0adf4","810":"4e54573a","827":"fa7a2c49","885":"7aca1791"}[chunkId] + ".chunk.js";
};